import {Stack, styled} from '@mui/system';

const HEADER_HEIGHT = '72px';

const StyledContainer = styled(Stack)`
  width: 100%;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  max-height: calc(100vh - ${HEADER_HEIGHT});
  padding: 28px 16px 64px 16px;
  gap: 24px;
`;

export {StyledContainer};
